import {Button, Col, Container, Modal, Row} from "react-bootstrap";
import "./FormPopup.scss";
import {useEffect, useState} from "react";
import {getDatabase, ref, push} from "firebase/database";
import {initializeApp} from "firebase/app";
// import firebase from "../firebase";

function FormPopUp(props) {

    const [loading, setLoading] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };
    useEffect(()=>{
        setErrorText("")
        setIsChecked(false)
        setLoading(false)
    },[props.onHide])

    const firebaseConfig = {
        apiKey: "AIzaSyCDfXjdFCADqHfwGN3Fa3Paeq3YRFiYiFE",
        authDomain: "atsuya-esg.firebaseapp.com",
        databaseURL: "https://atsuya-esg-default-rtdb.asia-southeast1.firebasedatabase.app",
        projectId: "atsuya-esg",
        storageBucket: "atsuya-esg.appspot.com",
        messagingSenderId: "942622794356",
        appId: "1:942622794356:web:b84158c864263b3cdd6721",
        measurementId: "G-T97TRGDPN2"
    };

    const app  = initializeApp(firebaseConfig);
    const database = getDatabase(app);

    const handleFormSubmit = async () => {

        if (loading) {
            return
        }

        if (document.getElementById("yourEmail").value.trim() === "" ||
            document.getElementById("yourEmail").value === null) {
            setErrorText("*Email field is mandatory")
            return;
        } else {
            setErrorText("")
        }

        if (!isChecked) {
            setErrorText("*Please accept our terms and conditions.")
            return;
        } else {
            setErrorText("")
        }


        // Assuming you have a function to get the form data
        const formData = {
            "name": document.getElementById("yourName1").value + document.getElementById("yourName1").value,
            "email": document.getElementById("yourEmail").value,
            "subject": document.getElementById("yourSubject").value + " " + document.getElementById("yourPhone").value,
            "message": document.getElementById("yourMessage").value,
        };


        // Push data to the 'data' node in the database
        const dataRef = ref(database, 'data');

        // Push data to the 'data' node in the database
        const newDataRef = push(dataRef, formData);

        // Set event listeners for completion and errors
        try {
            setLoading(true);
            await newDataRef;
            setLoading(false);
            props.onHide()
        } catch (error) {
            console.error('Error pushing data: ', error);
            setErrorText("Network error, please try again later.")
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };
        // try {
        //     setLoading(true);
        //
        //     const response = await fetch("https://atsuyatech.com/mailer", {
        //         method: "POST",
        //         headers: {
        //             "Content-Type": "application/json",
        //         },
        //         body: JSON.stringify(formData),
        //     });
        //
        //     if (response.ok) {
        //         setSuccess(true);
        //     } else {
        //         setSuccess(false);
        //     }
        //
        //     props.onHide()
        // } catch (error) {
        //     console.error("Error:", error);
        //     setSuccess(false);
        // } finally {
        //     setLoading(false);
        // }

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            style={{cursor: 'default'}}
        >
            <Modal.Body className="grid-example">
                <Container>
                    <Row>
                        <Col xs={12} md={6}>
                            <div className="inputsContainer">
                                <p className="inputsHeader">Full Name</p>
                                <input type="text" id="yourName1" className="inputField"/>
                            </div>
                        </Col>
                        <Col xs={12} md={6}>
                            <div className="inputsContainer">
                                <p className="inputsHeader">Last Name</p>
                                <input type="text" id="yourName2" className="inputField"/>
                            </div>
                        </Col>
                    </Row>


                    <Row>
                        <Col xs={12} md={6}>
                            <div className="inputsContainer">
                                <p className="inputsHeader">Email*</p>
                                <input type="text" id="yourEmail" className="inputField"/>
                            </div>
                        </Col>
                        <Col xs={12} md={6}>
                            <div className="inputsContainer">
                                <p className="inputsHeader">Phone</p>
                                <input type="text" id="yourPhone" className="inputField"/>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} md={6}>
                            <div className="inputsContainer">
                                <p className="inputsHeader">Organization</p>
                                <input type="text" id="yourSubject" className="inputField"/>
                            </div>
                        </Col>
                        <Col xs={12} md={6}>
                            <div className="inputsContainer">
                                <p className="inputsHeader">Job Title</p>
                                <input type="text" id="yourMessage" className="inputField"/>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} md={12}>
                            <div className="inputsContainer">
                                <p className="inputsHeader">Comments</p>
                                <input type="text" className="commentsField"/>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12}>
                            <div className="termsAndConditionsCont">
                                <p className="termsText">
                                    Atsuya is committed to protecting and respecting your privacy.
                                    If you would like to receive communication from our team,
                                    select the checkbox below:
                                </p>
                                <div className="checkBoxCont">
                                    <input type="checkbox" onChange={handleCheckboxChange}/>
                                    <p className="checkBoxText">
                                        I agree to the terms and conditions.
                                    </p>
                                </div>
                                <p className="termsText">{
                                    `You can unsubscribe from these communications at any time.Your
                                    privacy is important to us. By clicking submit, you consent to
                                    communication regarding this inquiry and to the storing and
                                    processing of your personal data in accordance with our `}
                                    <a className="policyText" href="https://atsuyatech.com/privacy-policy/">Privacy
                                        Policy.</a>
                                </p>
                                <div className="buttonContainer">
                                    <button className="submitBtn" onClick={handleFormSubmit}>
                                        {loading ? "Submitting..." : "Submit"}
                                    </button>
                                    <p className="laterText" onClick={props.onHide}>Maybe Later</p>
                                </div>
                                <div className="errortext">{errorText}</div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
        </Modal>
    );
}

export default FormPopUp;
